import { render, staticRenderFns } from "./LiveVideoPlayer.vue?vue&type=template&id=4836956a"
import script from "./LiveVideoPlayer.vue?vue&type=script&lang=js"
export * from "./LiveVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports